export default "__VITE_ASSET__Bsa5fQeK__"